const fetchProductLevelRidersFeature = (featureList, biData) => {
  // ADB RIDER
  if (
    biData.bi_request?.ADBRider &&
    !featureList.some((item) => item?.rider === "ABD")
  ) {
    featureList.push({
      label:
        "Gives your nominee an additional lumpsum amount in case of your death due to accident",
      rider: "ABD",
    });
  } else if (
    !biData.bi_request?.ADBRider &&
    featureList.some((item) => item?.rider === "ABD")
  ) {
    featureList = featureList.filter((item) => item?.rider !== "ABD");
  }

  // ATPD RIDER
  if (
    biData.bi_request?.ATPDRider &&
    !featureList.some((item) => item?.rider === "ATPD")
  ) {
    featureList.push({
      label:
        "Gives you additional lumpsum amount in case of total and permanent disability due to accident",
      rider: "ATPD",
    });
  } else if (
    !biData.bi_request?.ATPDRider &&
    featureList.some((item) => item?.rider === "ATPD")
  ) {
    featureList = featureList.filter((item) => item?.rider !== "ATPD");
  }

  // CRITICARE ILLNESS
  if (
    biData.bi_request?.CriticalIllnessRider &&
    !featureList.some((item) => item?.rider === "CriticalIllnessRider")
  ) {
    featureList.push({
      label:
        "Gives you a lumpsum payout if you're diagnosed with any of the 12 critical illnesses",
      rider: "CriticalIllnessRider",
    });
  } else if (
    !biData.bi_request?.CriticalIllnessRider &&
    featureList.some((item) => item?.rider === "CriticalIllnessRider")
  ) {
    featureList = featureList.filter(
      (item) => item?.rider !== "CriticalIllnessRider"
    );
  }

  // Income Benefit Rider
  if (
    biData.bi_request?.IncomeBenefitRider &&
    !featureList.some((item) => item?.rider === "IncomeBenefitRider")
  ) {
    featureList.push({
      label:
        "Additional monthly benefit for 150 months paid to your nominee in case of your death",
      rider: "IncomeBenefitRider",
    });
  } else if (
    !biData.bi_request?.IncomeBenefitRider &&
    featureList.some((item) => item?.rider === "IncomeBenefitRider")
  ) {
    featureList = featureList.filter(
      (item) => item?.rider !== "IncomeBenefitRider"
    );
  }

  // Waiver of Premium Rider
  if (
    biData.bi_request?.WaiverOfPremiumRider &&
    !featureList.some((item) => item?.rider === "WaiverOfPremiumRider")
  ) {
    featureList.push({
      label:
        "Removes the burden of paying future premiums, if you're diagnosed with any of the 12 critical illnesses or in case of accidental and total permanent disability",
      rider: "WaiverOfPremiumRider",
    });
  } else if (
    !biData.bi_request?.WaiverOfPremiumRider &&
    featureList.some((item) => item?.rider === "WaiverOfPremiumRider")
  ) {
    featureList = featureList.filter(
      (item) => item?.rider !== "WaiverOfPremiumRider"
    );
  }

  // Payor Waiver  Benefit Rider
  if (Number(biData.bi_request?.PayorWaiverBenefitRider) === 1) {
    if (
      Number(biData.bi_request?.PWB) === 1 &&
      !featureList.some((item) => item?.rider === "PWB1")
    ) {
      featureList.push({
        label:
          "If your death happens during ppt, your life assured will not have to pay any premiums and the policy benefits will continue for them",
        rider: "PWB1",
      });
      featureList = featureList.filter(
        (item) => item?.rider !== "PWB2" || item?.rider !== "PWB3"
      );
    }

    if (
      Number(biData.bi_request?.PWB) === 2 &&
      !featureList.some((item) => item?.rider === "PWB2")
    ) {
      featureList.push({
        label:
          "This Rider provides assistance in such a case - diagnosis of one of listed critical illnesses, a total and permanent disability caused by an accident . In such a case, all your remaining premium payments will be waived off and your policy benefits will continue unaffected",
        rider: "PWB2",
      });
      featureList = featureList.filter(
        (item) => item?.rider !== "PWB1" || item?.rider !== "PWB3"
      );
    }

    if (
      Number(biData.bi_request?.PWB) === 3 &&
      !featureList.some((item) => item?.rider === "PWB3")
    ) {
      featureList.push({
        label:
          "This Rider provides assistance in such a case - diagnosis of one of listed critical illnesses, a total and permanent disability caused by an accident or death. In such a case, all your remaining premium payments will be waived off and your policy benefits will continue unaffected",
        rider: "PWB3",
      });
      featureList = featureList.filter(
        (item) => item?.rider !== "PWB1" || item?.rider !== "PWB2"
      );
    }
  } else {
    featureList = featureList.filter(
      (item) =>
        item?.rider !== "PWB1" ||
        item?.rider !== "PWB2" ||
        item?.rider !== "PWB3"
    );
  }

  return featureList;
};

export default fetchProductLevelRidersFeature;
